import utils from "Sources/utils/utils";
//import NavUtils from "Sources/utils/navigation-utils";
const log = require("Sources/utils/logger")();
import LanguageManager from "Sources/services/language-manager";
import HtmlTemplate from "Views/partials/missions/mission-shared-user.html";

import "Styles/components/mission-shared-user.scss";

class MissionSharedUser
{
    constructor(options)
    {
        this.$container = $(options.container);
        this.hasRendered = false;
        this.missionSharedUser = options.missionSharedUser;
        this.onSharedUserRemoved = options.onSharedUserRemoved;
        this.selected = false;
    }

    get missionSharedUser()
    {
        return this._missionSharedUser;
    }

    set missionSharedUser(missionSharedUser)
    {
        this._missionSharedUser = missionSharedUser;
        this.updateMissionSharedUser();
    }

    static setUpMissionSharedUser(options)
    {
        let instance = new MissionSharedUser(options);
        instance.render();
        instance.setUpEventListeners();
        return instance;
    }

    setUpEventListeners()
    {
        const REMOVE_BTN_ID = ".remove-btn";

        let that = this;
        this.$element.find(REMOVE_BTN_ID).on("click", function(e)
        {
            that.removeUser();
        });
    }

    removeUser()
    {
        this.onSharedUserRemoved(this.missionSharedUser.key);
    }

    render()
    {
        this.hasRendered = false;
        this.$element = $(HtmlTemplate);
        this.$container.prepend(this.$element);
        LanguageManager.applyLocale(this.$element);
        this.updateMissionSharedUser();
        this.hasRendered = true;
    }

    show()
    {
        if (utils.isNotNull(this.$element) && this.$element.length)
        {
            this.$element.show();
        }
    }

    hide()
    {
        if (utils.isNotNull(this.$element) && this.$element.length)
        {
            this.$element.hide();
        }
    }

    destroy()
    {
        if (utils.isNotNull(this.$element) && this.$element.length)
        {
            this.$element.remove();
        }
    }

    updateMissionSharedUser()
    {
        if (utils.isNotNull(this.$element) && this.$element.length)
        {
            let $userNameLabel = this.$element.find("[data-bind-target='user-name-label']");
            $userNameLabel.empty();
            if (utils.isNotNull(this.missionSharedUser) && utils.isNotNull(this.missionSharedUser.email))
            {
                $userNameLabel.text(this.missionSharedUser.email);
            }
        }
    }

    getEmail()
    {
        return this.missionSharedUser.email;
    }

}

export default MissionSharedUser;



// WEBPACK FOOTER //
// ./app/js/components/mission-shared-user.js